import { NavList } from '@primer/react';
import { useGetLoggedInUser } from '@upright/ui/common/generic/hooks';
import { LinkWithSearch } from '@upright/ui/common/generic/components/navigation/link-with-search';
import { OfficeWorkerStreamlineCore } from '@upright/ui/icons';
import { getUserViewUrl } from '@upright/ui/untidy/urls';
import { UserViewViewMode } from '@upright/ui/views/user-view/types';
import { useHasSelfServeAccess } from '@upright/ui/views/user-view/use-self-serve-access';
import { TopLevelItemWrap } from '@upright/ui/views/shared/navigation/styled-nav-components';
import { useLocation } from 'react-router-dom';

/**
 * The rail's way into the organisation's own page: its plan, requests, members, policies and
 * guests. Listed for whoever the page is open to (`USE_SELF_SERVE_ACCESS`), so an organisation
 * that is not on it sees no row that leads to an error. The page itself lives under the signed-in
 * user's account route, so the row is current on that route and its account siblings stay in the
 * account rail.
 */
export function OrganizationRailRow() {
  const user = useGetLoggedInUser();
  const { pathname } = useLocation();
  const hasSelfServeAccess = useHasSelfServeAccess();
  if (!user?.username || !hasSelfServeAccess) return null;

  const to = getUserViewUrl(user.username, UserViewViewMode.ACCESS);
  return (
    <TopLevelItemWrap>
      <NavList.Item to={to} as={LinkWithSearch} aria-current={pathname === to ? 'page' : undefined}>
        <NavList.LeadingVisual>
          <OfficeWorkerStreamlineCore width={20} height={20} />
        </NavList.LeadingVisual>
        Organization
      </NavList.Item>
    </TopLevelItemWrap>
  );
}
